import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, Download, Award } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function PricingSection() {
  return <section className="bg-wellness-white py-24 px-6" id="pricing" data-id="element-87">
      <div className="max-w-4xl mx-auto" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-[3rem] p-8 md:p-16 shadow-2xl shadow-wellness-dark/10 border border-wellness-light-sage text-center relative overflow-hidden" data-id="element-89">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-wellness-light-sage/50 to-transparent" data-id="element-90" />
          <div className="absolute -right-20 -top-20 w-64 h-64 bg-wellness-sage/10 rounded-full blur-3xl" data-id="element-91" />
          <div className="absolute -left-20 -bottom-20 w-64 h-64 bg-wellness-gold/10 rounded-full blur-3xl" data-id="element-92" />

          <div className="relative z-10" data-id="element-93">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-wellness-dark mb-8" data-id="element-94">
              Tu inversión hoy
            </h2>

            <div className="flex justify-center items-center gap-4 mb-10" data-id="element-95">
              <span className="text-3xl text-wellness-dark/40 line-through font-medium" data-id="element-96">
                $27.00
              </span>
              <span className="text-6xl md:text-7xl font-bold text-wellness-gold drop-shadow-sm" data-id="element-97">
                $6.36
              </span>
            </div>

            <div className="bg-wellness-light-sage/50 rounded-3xl p-8 max-w-md mx-auto mb-10 text-left" data-id="element-98">
              <ul className="space-y-4" data-id="element-99">
                {['Guía completa PDF (7 días)', 'Plan de alimentación anti-inflamatorio', 'Rutinas y hábitos diarios', 'Acceso inmediato', 'Descarga ilimitada'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-100">
                    <CheckCircle2 className="w-6 h-6 text-wellness-green flex-shrink-0 mt-0.5" data-id="element-101" />
                    <span className="text-wellness-dark font-medium text-lg" data-id="element-102">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <a href="https://cuerpoencalma.it.com/cart/49295445262573:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('pricing_cta')} className="inline-block w-full md:w-auto bg-wellness-gold text-white px-12 py-5 rounded-full font-bold text-xl tracking-wide shadow-xl shadow-wellness-gold/30 hover:bg-yellow-600 transition-all hover:scale-105 active:scale-95 mb-8 text-center" data-id="element-103">
              DESCARGAR AHORA — $6.36
            </a>

            <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8 text-sm text-wellness-dark/70 font-medium" data-id="element-104">
              <div className="flex items-center gap-2" data-id="element-105">
                <Lock className="w-5 h-5 text-wellness-sage" data-id="element-106" />
                <span data-id="element-107">Pago Seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-108">
                <Download className="w-5 h-5 text-wellness-sage" data-id="element-109" />
                <span data-id="element-110">Descarga Inmediata</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-111">
                <Award className="w-5 h-5 text-wellness-sage" data-id="element-112" />
                <span data-id="element-113">Satisfacción Garantizada</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}